import CharacterNames from '../characterNames.json';

function generateCharacterName(): string {
  const names = CharacterNames;
  const randomIndex = Math.floor(Math.random() * names.length);
  return names[randomIndex];
}

export default generateCharacterName;
